import React from 'react'
import { toneColor } from '../../utils/tone'

export default function Badge({ tone = 'neutral', children, filled = false }) {
  const color = toneColor(tone)
  const style = filled
    ? { backgroundColor: color, color: '#0a0e17', borderColor: color }
    : { color, borderColor: `${color}55`, backgroundColor: `${color}14` }

  return (
    <span className="onds-chip" style={style}>
      {children}
    </span>
  )
}
